import {
  BottomSheet,
  List,
  ListItem,
  ListItemText,
  PageHeaderWrapper,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";

import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { useIsInHomeEnabled } from "../lib/useIsInHomeEnabled";
import { InHomeCommsBannerFooter } from "./Footer";

interface InHomeCommsBannerBottomSheetProps {
  modalState: UseModalState;
}

export function InHomeCommsBannerBottomSheet(props: InHomeCommsBannerBottomSheetProps) {
  const { modalState } = props;
  const isInHomeEnabled = useIsInHomeEnabled();
  if (!isInHomeEnabled) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet modalState={modalState} footer={<InHomeCommsBannerFooter />}>
        <PageHeaderWrapper variant="tertiary">
          <PageHeaderTopRow />
        </PageHeaderWrapper>
        <Stack spacing={10} sx={{ padding: 7, px: 10 }}>
          <Text variant="h3" textAlign="center">
            How to get paid
          </Text>
          <List>
            <ListItem divider>
              <ListItemText
                primary={
                  <Text semibold variant="body1">
                    1. Book a visit
                  </Text>
                }
              />
            </ListItem>
            <ListItem divider>
              <ListItemText
                primary={
                  <Text semibold variant="body1">
                    2. Contact agency for EMR
                  </Text>
                }
              />
            </ListItem>
            <ListItem divider>
              <ListItemText
                primary={
                  <Text semibold variant="body1">
                    3. Submit notes within 24 hours
                  </Text>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <Text semibold variant="body1">
                    4. Log the visit
                  </Text>
                }
              />
            </ListItem>
          </List>
        </Stack>
      </BottomSheet>
    </ThemeProvider>
  );
}
